import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PageLoader from "./components/PageLoader";

const TechnologyPage = lazy(() => import("./pages/TechnologyPage"));
const MarketingPage = lazy(() => import("./pages/MarketingPage"));
const DesignPage = lazy(() => import("./pages/DesignPage"));
const MarketingPlannerPage = lazy(() => import("./pages/MarketingPlannerPage"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Navigate to="/technology" replace />} />
            <Route path="/technology" element={<TechnologyPage />} />
            <Route path="/marketing" element={<MarketingPage />} />
            <Route path="/design" element={<DesignPage />} />
            <Route path="/marketing-planner-7Kf9Q2xM8V" element={<MarketingPlannerPage />} />
            <Route path="*" element={<Navigate to="/technology" replace />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
